import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "daterangepicker";
import moment from "moment";
import "daterangepicker/daterangepicker.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { CalendarIcon } from "../../icons";
import { Box } from "@mui/material";
const SingleDatePicker = ({ showNavigation = true, onDateChange }) => {
  const dateInputRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(moment()); // today


  useEffect(() => {
    const $input = $(dateInputRef.current);
    const start = moment(selectedDate);

    const picker = $input
      .daterangepicker(
        {
          singleDatePicker: true,
          showDropdowns: true,
          autoApply: true,
          autoUpdateInput: true,
          maxDate: moment(),
          opens: "auto",
          drops: "auto",
          startDate: selectedDate.toDate(),
          locale: { format: "MM/DD/YYYY" },
        },
        function (start) {
          const newDate = moment(start);
          setSelectedDate(newDate);
          if (onDateChange) onDateChange(newDate);
        }
      )
      .data("daterangepicker");

    $input.val(start.format("MM/DD/YYYY"));

    // Safely force refresh when calendar opens (fixes dropdown bugs)
    $input.on("show.daterangepicker", function () {
      setTimeout(() => {
        picker.updateView();
        picker.move();
      }, 10);
    });

    // Clean up on unmount
    return () => {
      $input.data("daterangepicker")?.remove();
    };
  }, []);

  const updateDate = (newDate) => {
    setSelectedDate(newDate);
    $(dateInputRef.current).val(newDate.format("MM/DD/YYYY"));
    if (onDateChange) onDateChange(newDate);
  };

  const goToPreviousDate = () => updateDate(moment(selectedDate).subtract(1, "days"));


  const goToNextDate = () => updateDate(moment(selectedDate).add(1, "days"));

  const openCalendar = () => {
    $(dateInputRef.current).trigger("click");
  };

  return (
    <>
      <style>
        {`
  .daterangepicker td.off.disabled,
  .daterangepicker td.disabled {
    background-color: #f2f2f2 !important;
    color: #aaa !important;
    cursor: not-allowed !important;
    border-radius: 0px !important;
    text-decoration: none !important;
  }
`}
      </style>

      <Box sx={{ marginRight: { xl: '10px', lg: '10px', md: '10px', sm: '10px', xs: '10px' } }}>
        <div className="d-flex align-items-center space-x-2 gap-1">
          {showNavigation && (
            <Box sx={{ display: { xl: 'block', lg: 'block', md: 'block', sm: 'block', xs: 'none' } }}>
              <button
                onClick={goToPreviousDate}
                style={{
                  background: "#fff",
                  padding: "6px 15px",
                  width: "50px",
                  height: "38px",
                  border: "1px solid rgba(229, 232, 235, 1)",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowBackIosIcon sx={{ width: "15px", height: "15px" }} />
              </button>
            </Box>
          )}

          <div className="form-group position-relative">
            <input
              style={{
                background: "#fff",
                display: "flex",
                fontSize: "14px",
                padding: "6px 15px",
                alignItems: "center",
                justifyContent: "center",
                width: { xl: "257px", lg: '200px', md: '200px', sm: '200px', xs: '200px' },
                border: "1px solid rgba(229, 232, 235, 1)",
                borderRadius: "20px",
                height: "38px",
              }}
              type="text"
              ref={dateInputRef}
              className="form-control pe-5"
              placeholder="Select date"
              readOnly
            />
            <span
              onClick={openCalendar}
              style={{
                position: "absolute",
                right: "0px",
                top: "50%",
                cursor: "pointer",
                color: "#555",
              }}
            >
              <CalendarIcon
                style={{
                  position: "absolute",
                  right: "13px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
            </span>
          </div>

          {showNavigation && (
            <Box sx={{ display: { xl: 'block', lg: 'block', md: 'block', sm: 'block', xs: 'none' } }}>
              <button
                onClick={goToNextDate}
                style={{
                  background: "#fff",
                  padding: "6px 15px",
                  width: "50px",
                  height: "38px",
                  border: "1px solid rgba(229, 232, 235, 1)",
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ArrowForwardIosIcon sx={{ width: "15px", height: "15px" }} />
              </button>
            </Box>

          )}
        </div>
      </Box>
    </>
  );
};

export default SingleDatePicker;